/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const SequenceSubType = {
    None: 'None',
    Values: 'Values',
    Positions: 'Positions',
    ChamberNumbers: 'ChamberNumbers'
} as const;
export type SequenceSubType = typeof SequenceSubType[keyof typeof SequenceSubType];


export function SequenceSubTypeFromJSON(json: any): SequenceSubType {
    return SequenceSubTypeFromJSONTyped(json, false);
}

export function SequenceSubTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): SequenceSubType {
    return json as SequenceSubType;
}

export function SequenceSubTypeToJSON(value?: SequenceSubType | null): any {
    return value as any;
}

/**
 * Check if a given object implements the SequenceSubType interface.
 */
 export function instanceOfSequenceSubType(value: any): value is SequenceSubType {
    return Object.values(SequenceSubType).includes(value)
}

